<template>
    <div id="column" class="mt">
        <a-row type="flex" justify="start">
            <a-col :span="6" >
                <a-row style="margin-bottom: 10px"type="flex" justify="start">
                    <a-col>
                        <a-button type="primary" @click="batchSave" size="small">{{ $t('reportSetting.BatchSave') }}</a-button>
                    </a-col>
                    <a-col style="margin: 0 3px;">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('reportSetting.SelectAllforSearchable') }}</span>
                            </template>
                            <a-switch size="small" @change="searchableAllChange" v-model="searchableAll"></a-switch>
                        </a-tooltip>
                    </a-col>
                    <a-col>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('reportSetting.SelectAllforDisaplyable') }}</span>
                            </template>
                            <a-switch size="small" @change="disableAllChange" v-model="disableAll"></a-switch>
                        </a-tooltip>
                    </a-col>
                </a-row>
                <a-row style="height: 70vh;overflow: hidden;overflow-y: auto">
                    <draggable class="list-group" :list="detailList" @end="end">
                        <div
                                class="list-group-item"
                                v-for="(element, index) in detailList"
                                :class="{'activeBlue':targetIndex == element.columnName}"
                                :key="element.columnName"
                        >
                            <a-row>
                                <a-row type="flex" justify="start">
                                    <a-col>
                                        <a-tooltip placement="topLeft">
                                            <template slot="title">
                                                <span>{{ $t('generic.Searchable') }}</span>
                                            </template>
                                            <a-switch size="small" v-model="element.searchable"></a-switch>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col style="margin: 0 3px;">
                                        <a-tooltip placement="topLeft">
                                            <template slot="title">
                                                <span>{{ $t('generic.Displayable') }}</span>
                                            </template>
                                            <a-switch size="small" v-model="element.displayable"></a-switch>
                                        </a-tooltip>
                                    </a-col>
                                </a-row>
                                <a-row style="text-align: left;text-decoration: underline" class="sbxs">
                                    <a-col @click="listClick(element,index)" >{{ element.columnName }}</a-col>
                                </a-row>
                            </a-row>
                        </div>
                    </draggable>
                </a-row>
            </a-col>
            <a-col :span="18">
                <a-row style="margin-bottom: 10px"type="flex" justify="start">
                    <a-col>
                        <a-button type="primary" @click="saveFromCloumn(false)" size="small">{{ $t('publicLang.Save') }}</a-button>
                    </a-col>
                </a-row>
                <a-row style="height: 70vh;overflow: hidden;overflow-y: auto;margin-left: 10px;">
                    <a-form :form="form" >
                        <ul style="border: 1px solid #efefef">
                            <li class="editLi" @click="oneLiDetail" style="cursor: pointer">
                                <a-row type="flex">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{ $t('pubGicSet.ColumnName') }}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input disabled style="width: 100%;" size="small"
                                                     v-decorator="[
                                                                  'columnName',
                                                                  {
                                                                    initialValue: etailObj.columnName,
                                                                  },
                                                               ]"
                                                     :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{ $t('roleGe.FieldType') }}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-select
                                                    allowClear
                                                    @change="fieldTypeChange"
                                                    :placeholder="$t('publicLang.PleaseSelect')"
                                                    style="width: 100%"
                                                    size="small"
                                                    v-decorator="[
                                                  'fieldType',
                                                  {
                                                    initialValue: etailObj.fieldType,
                                                  },
                                                ]"
                                            >
                                                <a-select-option value="String">String</a-select-option>
                                                <a-select-option value="Integer">Integer</a-select-option>
                                                <a-select-option value="Decimal">Decimal</a-select-option>
                                                <a-select-option value="Date">Date</a-select-option>
                                                <a-select-option value="Datetime">Datetime</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label >{{ $t('generic.DataFormat') }}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-select
                                                    allowClear
                                                    v-if="etailObj.fieldType == 'Decimal'"
                                                    size="small"
                                                    v-decorator="[
                                                          'dataFormat',
                                                           {
                                                             initialValue: etailObj.dataFormat,
                                                           },
                                                        ]"
                                                    style="width: 100%"
                                                    :placeholder="$t('publicLang.PleaseSelect')">
                                                <a-select-option value="0">Default</a-select-option>
                                                <a-select-option value="1">x.x</a-select-option>
                                                <a-select-option value="2">x.xx</a-select-option>
                                                <a-select-option value="3">x.xxx</a-select-option>
                                                <a-select-option value="4">x.xxxx</a-select-option>
                                                <a-select-option value="5">x.xxxxx</a-select-option>
                                                <a-select-option value="6">x.xxxxxx</a-select-option>
                                                <a-select-option value="7">x.xxxxxxx</a-select-option>
                                                <a-select-option value="8">x.xxxxxxxx</a-select-option>
                                            </a-select>
                                            <a-select
                                                    allowClear
                                                    size="small"
                                                    v-else-if="etailObj.fieldType == 'Date'"
                                                    style="width: 100%"
                                                    :placeholder="$t('publicLang.PleaseSelect')"
                                                    v-decorator="[
                                                          'dataFormat',
                                                           {
                                                             initialValue: etailObj.dataFormat,
                                                           },
                                                        ]" >
                                                <a-select-option value="yyyyMMdd">yyyyMMdd</a-select-option>
                                                <a-select-option value="yyyy-MM-dd">yyyy-MM-dd</a-select-option>
                                                <a-select-option value="yyyy/MM/dd">yyyy/MM/dd</a-select-option>
                                                <a-select-option value="dd-MM-yyyy">dd-MM-yyyy</a-select-option>
                                                 <a-select-option value="dd/MM/yyyy">dd/MM/yyyy</a-select-option>
                                                <a-select-option value="MM-dd-yyyy">MM-dd-yyyy</a-select-option>
                                                <a-select-option value="dd/MMM/yyyy">dd/MMM/yyyy</a-select-option>
                                                <a-select-option value="dd-MMM-yyyy">dd-MMM-yyyy</a-select-option>
                                            </a-select>
                                            <a-input
                                                    v-else
                                                    size="small"
                                                    v-decorator="[
                                                          'dataFormat',
                                                           {
                                                             initialValue: etailObj.dataFormat,
                                                           },
                                                        ]"
                                                    :placeholder="$t('publicLang.PleaseSelect')" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label >{{$t('pubGicSet.Width')}}</label><span style="color: red;">*</span>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                      'columnWidth',
                                                      {
                                                        initialValue: etailObj.columnWidth,
                                                        rules: [
                                                          { required: true, message: $t('publicLang.Required')},
                                                        ]
                                                      }
                                                    ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label >{{$t('reportSetting.EnglishName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'dispNameEn',
                                                  {
                                                      initialValue: etailObj.dispNameEn,
                                                    rules: [
                                                      { required: false, message: $t('publicLang.Required')},
                                                    ]
                                                  }
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.SimplifiedCNName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                      'dispNameScn',
                                                      {
                                                          initialValue: etailObj.dispNameScn,
                                                      }
                                                    ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.TraditionalCNName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'dispNameTcn',
                                                  {
                                                       initialValue: etailObj.dispNameTcn,
                                                  }
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.EnglishTipsName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'descrEn',
                                                  {
                                                       initialValue: etailObj.descrEn,
                                                  }
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.SimplifiedCNTipsName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'descrSimpl',
                                                  {initialValue: etailObj.descrSimpl,}
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.TraditionalCNTipsName')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                   'descrTradi',
                                                  {initialValue: etailObj.descrTradi,}
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label >{{$t('generic.Searchable')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-switch size="small" :disable="etailObj.calcType ? true : false" v-decorator="[
                                                'searchable',
                                                    {
                                                        initialValue:etailObj.searchable,
                                                         valuePropName: 'checked'
                                                    }]" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('generic.Displayable')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-switch size="small" v-decorator="[
                                                'displayable',
                                                {
                                                    initialValue:etailObj.displayable,
                                                    valuePropName: 'checked'
                                                }]" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.DisplaySeq')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    disabled
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'dispSeq',
                                                  {
                                                      initialValue:etailObj.dispSeq,
                                                  }
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('pubGicSet.printReportColumn')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'printReportColumn',
                                                  {
                                                      initialValue:etailObj.printReportColumn,
                                                  }
                                                ]"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi" v-if="false">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('generic.SortSeq')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-input
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width: 100%;"
                                                    v-decorator="[
                                                  'sortSeq',
                                                  {initialValue:etailObj.sortSeq,}
                                                ]"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi" v-if="false">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('pubGicSet.OrderBy')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-select
                                                    allowClear
                                                    :placeholder="$t('publicLang.PleaseSelect')"
                                                    size="small"
                                                    style="width: 100%"
                                                    v-decorator="[
                                                      'orderBy',
                                                      {initialValue:etailObj.orderBy,}
                                                   ]"
                                            >
                                                <a-select-option value="ASC">Asc</a-select-option>
                                                <a-select-option value="DESC">Desc</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                            <li class="editLi" v-if="false">
                                <a-row type="flex" justify="start">
                                    <a-col :span="12" class='editLileft'>
                                        <label>{{$t('reportSetting.CalculateType')}}</label>
                                    </a-col>
                                    <a-col :span="12" class="editLiRight">
                                        <a-form-item>
                                            <a-select
                                                    allowClear
                                                    :placeholder="$t('publicLang.PleaseSelect')"
                                                    size="small"
                                                    style="width: 100%"
                                                    v-decorator="[
                                                      'calcType',
                                                       {initialValue:etailObj.calcType,}
                                                   ]"
                                            >
                                                <a-select-option value="Count">Count</a-select-option>
                                                <a-select-option value="Sum">Sum</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </li>
                        </ul>
                    </a-form>
                </a-row>
            </a-col>
        </a-row>
        <a-modal :title="$t('reportSetting.ColumnDetail')" v-model="ColumnDetailVis" width="40%">
            <template slot="footer">
                <a-button @click="CloseColumnDetail">{{ $t('publicLang.Close') }}</a-button>
            </template>
           <p>{{etailObj.statement}}</p>
        </a-modal>
    </div>
</template>
<script>
    import draggable from "vuedraggable"
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props:{
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        components: {
            draggable
        },
        watch:{
            headerUid(v){
                this.init()
            }
        },
        data(){
            return{
                form: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                detailList: [], // from right data
                etailObj: {}, // 编辑当前数据 展示
                targetIndex: 0,
                ColumnDetailVis: false,
                disableAll: false,// disable全选
                searchableAll: false, // searchable 全选
            }
        },
        created(){
            this.init()
        },
        methods:{
//            left 选择提交
            batchSave(){
                let arr = []
                for(let i in this.detailList){
                    let obj = {}
                    obj.columnName = this.detailList[i].columnName
                    obj.searchable = this.detailList[i].searchable ? '1': '0'
                    obj.displayable = this.detailList[i].displayable ? '1': '0'
                    arr.push(obj)
                }
                ajax.post(api.REPORTGENERICCOLUMN,{columnDtoList: arr,headerUid: this.headerUid,reGenerateSql: false,batch:1}).then(res=>{
                    if(res.code == 200){
                        this.init()
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            disableAllChange(){
                for(let i in this.detailList){
                    if(this.disableAll){
                        this.detailList[i].displayable = true
                    }else{
                        this.detailList[i].displayable = false
                    }

                }
            },
            searchableAllChange(){
                for(let i in this.detailList){
                    if(this.searchableAll){
                        this.detailList[i].searchable = true
                    }else{
                        this.detailList[i].searchable = false
                    }
                }
            },
            //      left 选择提交end
            //            头部点击查看详情
            CloseColumnDetail(){
                this.ColumnDetailVis = false
            },
            oneLiDetail(){
                this.ColumnDetailVis = true
            },
            fieldTypeChange(val){
                this.etailObj.fieldType = val
                this.etailObj.dataFormat = null
            },
//            初始化数据
            init(){
                this.etailObj = {}
                ajax.get(api.REPORTGENERICCOLUMN,{headerUid: this.headerUid}).then(res=>{
                    if(res.code == 200){
                        this.detailList = res.data.detailList
                        if(this.detailList.length > 0 ){
                            for(let i in this.detailList){
                                this.detailList[i].searchable = this.detailList[i].searchable == "1" ? true : false
                                this.detailList[i].displayable = this.detailList[i].displayable == "1" ? true : false
                            }
                            this.targetIndex = this.detailList[0].columnName
                            this.etailObj =  this.detailList[0]
                        }
                    }
                })
            },
            editSortPubAjax(){
                ajax.get(api.REPORTGENERICCOLUMN,{headerUid: this.headerUid}).then(res=>{
                    this.detailList = res.data.detailList
                    if(this.detailList.length > 0 ){
                        for(let i in this.detailList){
                            this.detailList[i].searchable = this.detailList[i].searchable == "1" ? true : false
                            this.detailList[i].displayable = this.detailList[i].displayable == "1" ? true : false
                            if(this.detailList[i].columnName == this.targetIndex){
                                this.etailObj =  this.detailList[i]
                            }
                        }
                    }
                })
            },
//            推拽排序后重新请求
            end(){
                let arr = []
                for(let i in this.detailList){
                    arr.push(this.detailList[i].columnName)
                }
                ajax.post(api.REPORTGENERICCOLUMNSEQ,{columnNameList: arr, headerUid: this.headerUid}).then(res=>{
                    this.editSortPubAjax()
                })
            },
//            点击当前变色 那当前edit data
            listClick(element,index){
                this.etailObj = {}
                this.form.resetFields();
                this.targetIndex = element.columnName
                this.etailObj =  this.detailList[index]
            },
//            edit 保存
            saveFromCloumn(type){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let params = values
                        params.searchable = params.searchable ? '1': '0'
                        params.displayable = params.displayable ? '1': '0'
                        ajax.post(api.REPORTGENERICCOLUMN,{columnDtoList: [values],headerUid: this.headerUid,reGenerateSql: type}).then(res=>{
                            if(res.code == 200){
                                this.editSortPubAjax()
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
    .list-group-item{
        text-align: center;
        position: relative;
    }
    .activeBlue{
        background: #1890ff;
        color: #fff;
    }
    .editLi{
        border-bottom:1px solid #efefef;
        .editLileft{
            padding-left: 4px;
            display: flex;
            align-items: center;
        }
        .editLiRight{
            border-left: 1px solid #efefef;
            padding:0 4px;
        }
    }
</style>